import { omniAtom } from "src/utils/atoms";

import { Toast } from "./types";

export const toastsAtom = omniAtom({
  key: "toasts",
  value: [] as Toast[],
});
